import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.9769,
			cy: 11.5,
			r: 10.5,
			fill: "#F0F4FD",
			stroke: "#001E50"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.4769,
			y: 4,
			width: 2.99121,
			height: 2.88755,
			rx: 1,
			fill: "#001E50"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.4769,
			y: 7.88757,
			width: 2.99121,
			height: 11.5502,
			rx: 1,
			fill: "#001E50"
		})
	]
});
export default SvgInfo;
